import { IApikey, ICustomerData } from "@/entities";
import { IApikeyRepository } from "@/repositories/apikey";
import { Auth } from "aws-amplify";
import { IAuthenticationService } from "./authentication.types";
import jwt_decode from "jwt-decode";
import sign from 'jwt-encode';

export class AuthenticationService implements IAuthenticationService {
    apikey: IApikey | undefined;

    constructor(private repository: IApikeyRepository) {}

    async getApikey(): Promise<IApikey | undefined> {
        if (this.apikey) {
            if (!this.apikey.isExpired()) {
                return this.apikey;
            }
        }
        const apikey = await this.repository.get();
        this.apikey = apikey;
        return apikey;
    }

    async getIdToken(): Promise<string | undefined> {
        const session = await Auth.currentSession();
        console.log({ session });
        return session.getIdToken().getJwtToken();
    }

    async getCustomerIdToken(customer: ICustomerData): Promise<string> {
        const idToken = await this.getIdToken();
        const decoded: any = jwt_decode(idToken!);
        // const tokenize = idToken!.split(".");

        if (customer.phone_number) {
            decoded["cognito:username"] = customer.phone_number;
        } else if (customer.email){
            decoded["cognito:username"] = customer.phone_number;
        }

        return sign(decoded,"");

        // console.log({decoded});

        // const payload = btoa(JSON.stringify(decoded));

        // console.log({payload})

        // tokenize[1] = payload;
        

        // console.log({ decoded });
        // return tokenize.join();
    }
}
